import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    inject,
    SecurityContext,
    ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'pf-section',
    standalone: true,
    imports: [],
    templateUrl: './section.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class SectionComponent implements OnChanges {
    @Input() name!: string;
    @Input() title!: string;
    @Input() subtitle: string;

    sanitizedTitle = '';
    private readonly sanitizer = inject(DomSanitizer);

    get id(): string | null {
        const normalized = this.name?.trim()?.replaceAll(/\s+/g, '-').toLowerCase();
        return normalized ? 'sec-' + normalized : null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['title']) {
            this.sanitizedTitle =
                this.sanitizer.sanitize(SecurityContext.HTML, this.title ?? '') ?? '';
        }
    }
}
